
export const isFilterDefault = (filterOptions) => {

    let hasChangedFilters = false;

    for (const [filterKey, filterVal] of Object.entries(filterOptions)) {

        if (filterVal !== 'all') {

            hasChangedFilters = true;
            break;

        }

    }

    return !hasChangedFilters;

};

export const isDisplayDefault = (displayOptions) => {

    return (displayOptions === 'all');
};

export const isDatesDefault = (dates, earliest) => {

    return (dates['start'] === earliest);
}
